function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.66667 6.66667H4.00667V8H2.66667V6.66667Z",
  fill: "#1F2939"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33333 6.66667H6.67333V8H5.33333V6.66667Z",
  fill: "#1F2939"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 6.66667H9.34V8H8V6.66667Z",
  fill: "#1F2939"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.66667 8.66667H4.00667V10H2.66667V8.66667Z",
  fill: "#1F2939"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33333 8.66667H6.67333V10H5.33333V8.66667Z",
  fill: "#1F2939"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33333 8.66667V12H8V8.66667H9.33333Z",
  fill: "#1F2939"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M2.66667 10.6667H4.00667V12H2.66667V10.6667Z",
  fill: "#1F2939"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33333 10.6667H6.67333V12H5.33333V10.6667Z",
  fill: "#1F2939"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H12V14.6667H0V0ZM1.33333 1.33333V4H10.6667V1.33333H1.33333ZM10.6667 5.33333H1.33333V13.3333H10.6667V5.33333Z",
  fill: "#1F2939"
});

function SvgAccrual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccrual);
export default __webpack_public_path__ + "static/media/accrual.1fa6bc28.svg";
export { ForwardRef as ReactComponent };